import { render, staticRenderFns } from "./AccessLevelToggle.vue?vue&type=template&id=1163aac4&"
import script from "./AccessLevelToggle.vue?vue&type=script&lang=ts&"
export * from "./AccessLevelToggle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports